import { jsx as o, jsxs as I } from "react/jsx-runtime";
import m from "styled-components";
import { Icon as v } from "./icon.js";
import h, { useState as g, useRef as $, useEffect as f } from "react";
import "@fcamna/shared-component-foundations";
import { u as w } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import "@fcamna/shared-icons";
import "./index-65016bfa.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
const T = m.button`
  height: ${(e) => e.theme.components.menu.ellipses.EllipsesContainer.height};
  width: ${(e) => e.theme.components.menu.ellipses.EllipsesContainer.width};
  border-radius: ${(e) => e.theme.components.menu.ellipses.EllipsesContainer.borderRadius};
  &:hover {
    background-color: ${(e) => e.theme.components.menu.ellipses.EllipsesContainer.hover.backgroundColor};
  }
  background-color: ${(e) => e.$active ? e.theme.components.menu.ellipses.EllipsesContainer.backgroundColor.active : e.theme.components.menu.ellipses.EllipsesContainer.backgroundColor.default};

  color: ${(e) => e.disabled ? e.theme.components.menu.ellipses.EllipsesContainer.color.disabled : e.theme.components.menu.ellipses.EllipsesContainer.color.default};
  border-color: ${(e) => e.theme.components.menu.ellipses.EllipsesContainer.borderColor};
  cursor: ${(e) => e.theme.components.menu.ellipses.EllipsesContainer.cursor};
  display: ${(e) => e.theme.components.menu.ellipses.EllipsesContainer.display};
  justify-content: ${(e) => e.theme.components.menu.ellipses.EllipsesContainer.justifyContent};
  align-items: ${(e) => e.theme.components.menu.ellipses.EllipsesContainer.alignItems};

  &:focus-visible {
    ${(e) => `
          outline: ${e.theme.components.menu.ellipses.EllipsesContainer.focusVisible.outline};
          border-radius: ${e.theme.components.menu.ellipses.EllipsesContainer.focusVisible.borderRadius};
          padding: ${e.theme.components.menu.ellipses.EllipsesContainer.focusVisible.padding};
          outline-offset:${e.theme.components.menu.ellipses.EllipsesContainer.focusVisible.outlineOffset};
        `}
  }
`, L = ({ active: e = !1, ...n }) => /* @__PURE__ */ o(
  T,
  {
    $active: e,
    ...n,
    children: /* @__PURE__ */ o(
      v,
      {
        name: "moreVertical",
        size: "s"
      }
    )
  }
), k = "Escape", M = m.div`
  display: ${(e) => e.theme.components.menu.menu.MainWrapper.display};
  justify-content: ${(e) => e.theme.components.menu.menu.MainWrapper.justifyContent};
  position: ${(e) => e.theme.components.menu.menu.MainWrapper.position};
`, R = m.div`
  display: ${(e) => e.theme.components.menu.menu.TriggerWrapper.display};
  justify-content: ${(e) => e.theme.components.menu.menu.TriggerWrapper.justifyContent};
`, j = m.div`
  display: ${({ $menuOpen: e, ...n }) => e ? n.theme.components.menu.menu.ContentWrapper.display.menuOpen : n.theme.components.menu.menu.ContentWrapper.display.default};
  position: ${(e) => e.theme.components.menu.menu.ContentWrapper.position};
  z-index: ${(e) => e.theme.components.menu.menu.ContentWrapper.zIndex};
  box-sizing: ${(e) => e.theme.components.menu.menu.ContentWrapper.boxSizing};
  min-height: ${(e) => e.theme.components.menu.menu.ContentWrapper.minHeight};
  width: ${(e) => e.theme.components.menu.menu.ContentWrapper.width};
  border: ${(e) => e.theme.components.menu.menu.ContentWrapper.border};
  border-radius: ${(e) => e.theme.components.menu.menu.ContentWrapper.borderRadius};
  background-color: ${(e) => e.theme.components.menu.menu.ContentWrapper.backgroundColor};
  box-shadow: ${(e) => e.theme.components.menu.menu.ContentWrapper.boxShadow};
  top: ${(e) => e.theme.components.menu.menu.ContentWrapper.top};
  right: ${({ $leftAligned: e, ...n }) => e ? n.theme.components.menu.menu.ContentWrapper.right.leftAligned : n.theme.components.menu.menu.ContentWrapper.right.default};
`, S = m.ul`
  list-style: ${(e) => e.theme.components.menu.menu.ContentList.listStyle};
  margin: ${(e) => e.theme.components.menu.menu.ContentList.margin};
  padding: ${(e) => e.theme.components.menu.menu.ContentList.padding};
`, G = ({ menuButton: e, children: n, uniqueIdentifier: p, className: s }) => {
  const i = w({ label: "Overflow Menu" }), [t, c] = g(!1), l = $(null), a = $(null), [C, d] = g(!1);
  e || (e = /* @__PURE__ */ o(L, { active: t }));
  const b = () => {
    t ? u() : E();
  }, W = (r) => {
    switch (r.key) {
      case k:
        u();
        break;
      default:
        return;
    }
  }, y = h.cloneElement(e, {
    onKeyUp: W,
    onClick: b
  }), E = () => {
    c(!0);
  }, u = h.useCallback(() => {
    c(!1);
  }, []);
  return f(() => {
    a.current && (a.current.getBoundingClientRect().x < 0 ? d(!0) : d(!1));
  }, [t]), f(() => {
    const r = (x) => {
      l.current && !l.current.contains(x.target) && t && u();
    };
    return window.addEventListener("click", r), () => {
      window.removeEventListener("click", r);
    };
  }, [t, u]), /* @__PURE__ */ I(
    M,
    {
      ref: l,
      className: s,
      ...i,
      children: [
        /* @__PURE__ */ o(R, { children: y }),
        /* @__PURE__ */ o(
          j,
          {
            $menuOpen: t,
            id: p,
            role: "menu",
            "aria-hidden": !t,
            ref: a,
            $leftAligned: C,
            children: /* @__PURE__ */ o(S, { children: n })
          }
        )
      ]
    }
  );
}, z = m.li`
  border-radius: ${(e) => e.theme.components.menu.menuItem.ListWrapper.borderRadius};
  background-color: ${(e) => e.theme.components.menu.menuItem.ListWrapper.backgroundColor};
  min-height: ${(e) => e.theme.components.menu.menuItem.ListWrapper.minHeight};
  padding: ${(e) => e.theme.components.menu.menuItem.ListWrapper.padding};

  &:hover:not([disabled]) {
    background-color: ${(e) => e.theme.components.menu.menuItem.ListWrapper.hoverNotDisabled.backgroundColor};
  }

  &:focus-visible:not([disabled]) {
    outline: ${(e) => e.theme.components.menu.menuItem.ListWrapper.focusVisibleNotDisabled.outline};
    border-radius: ${(e) => e.theme.components.menu.menuItem.ListWrapper.focusVisibleNotDisabled.borderRadius};
  }
`, O = m.button`
  all: ${(e) => e.theme.components.menu.menuItem.ItemText.all};
  width: ${(e) => e.theme.components.menu.menuItem.ItemText.width};
  display: ${(e) => e.theme.components.menu.menuItem.ItemText.display};
  word-wrap: ${(e) => e.theme.components.menu.menuItem.ItemText.wordWrap};
  cursor: ${({ disabled: e, ...n }) => e ? n.theme.components.menu.menuItem.ItemText.cursor.disabled : n.theme.components.menu.menuItem.ItemText.cursor.default};
  justify-content: ${({ trailingIcon: e, ...n }) => e && n.theme.components.menu.menuItem.ItemText.justifyContent};
  color: ${({ disabled: e, ...n }) => e ? n.theme.components.menu.menuItem.ItemText.color.disabled : n.theme.components.menu.menuItem.ItemText.color.default};
  font-family: ${(e) => e.theme.components.menu.menuItem.ItemText.fontFamily};
  font-size: ${(e) => e.theme.components.menu.menuItem.ItemText.fontSize};
  letter-spacing: ${(e) => e.theme.components.menu.menuItem.ItemText.letterSpacing};
  line-height: ${(e) => e.theme.components.menu.menuItem.ItemText.lineHeight};
`, V = m.div`
  display: ${(e) => e.theme.components.menu.menuItem.LeadingIconWrapper.display};
  align-items: ${(e) => e.theme.components.menu.menuItem.LeadingIconWrapper.alignItems};
  margin-right: ${(e) => e.theme.components.menu.menuItem.LeadingIconWrapper.marginRight};
  color: ${(e) => e.theme.components.menu.menuItem.LeadingIconWrapper.color};

  svg,
  img {
    width: ${(e) => e.theme.components.menu.menuItem.LeadingIconWrapper.svg.width};
    height: ${(e) => e.theme.components.menu.menuItem.LeadingIconWrapper.svg.height};
  }
`, A = m.div`
  display: ${(e) => e.theme.components.menu.menuItem.TrailingIconWrapper.display};
  float: ${(e) => e.theme.components.menu.menuItem.TrailingIconWrapper.float};
  color: ${(e) => e.theme.components.menu.menuItem.TrailingIconWrapper.color};

  svg,
  img {
    width: ${(e) => e.theme.components.menu.menuItem.TrailingIconWrapper.svg.width};
    height: ${(e) => e.theme.components.menu.menuItem.TrailingIconWrapper.svg.height};
  }
`, J = ({ onClick: e, children: n, leadingIcon: p, trailingIcon: s, disabled: i = !1 }) => /* @__PURE__ */ o(
  z,
  {
    disabled: i,
    tabIndex: i ? 1 : 0,
    onKeyDown: (t) => {
      (t.code === "Space" || t.code === "Enter") && e && e();
    },
    children: /* @__PURE__ */ I(
      O,
      {
        tabIndex: -1,
        disabled: i,
        onClick: e,
        trailingIcon: s,
        children: [
          p && /* @__PURE__ */ o(V, { children: p }),
          n,
          s && /* @__PURE__ */ o(A, { children: s })
        ]
      }
    )
  }
);
export {
  L as Ellipses,
  G as Menu,
  J as MenuItem
};
